import React from "react";
import logger from "logger";
import { SnackbarProvider, useSnackbar } from "notistack";
import {
  BrowserRouter,
  HashRouter,
  Switch,
  Route,
  useHistory,
} from "react-router-dom";
import axios from "axios";
import Login from "./Login";
import HomePage from "./HomePage";
import Admin from "./Admin";
import { Accounts } from "./Accounts";
import { AccountDetail } from "./AccountDetail";
import { TaskHistory } from "./TaskHistory";
import { WallRemover } from "./WallRemover";
import { RunningTasks } from "./RunningTasks";
import { RunningTasksAdmin } from "./RunningTasksAdmin";
import PrivateRoute from "./Utils/PrivateRoute";
import Constants from "./Utils/Constants";
import toastMaker from "Common/toastmaker";

import { DialogProvider } from "DialogProvider";
import LoadingProgress from "Common/LoadingProgress";

import store from "./store";
import { Provider, useSelector } from "react-redux";

import "./App.css";

const setInterceptor = (history) => {
  axios.interceptors.response.use((response) => {
    logger.log("response interceptor", response, response.data);
    const {
      data: { ok, message, messagecode },
    } = response;
    if (ok !== null) {
      if (ok === false) {
        toastMaker.makeToast(message, {
          variant: "error",
        });
        store.dispatch({ type: "ISLOADING", payload: false });
        if (messagecode && messagecode === "11552") {
          logger.log("Redirecting to login");
          if (history) {
            history.push(Constants.login);
          } else {
            window.location = Constants.login;
          }
        }
      }
    }
    return Promise.resolve(response);
  }, null);
};

function App() {
  const { enqueueSnackbar } = useSnackbar();
  toastMaker.makeToast = enqueueSnackbar;

  const isLoading = useSelector(({ rootScope }) => rootScope.isLoading);
  const history = useHistory();
  setInterceptor(history);

  logger.log("App.css loaded");
  return (
    <>
      {isLoading && <LoadingProgress />}
      <HashRouter /*basename={Constants.basepath}*/>
        <Switch>
          {/*
            <Route exact path={Constants.unsubscribe} component={Unsubscribe} />
             */}
          <PrivateRoute
            exact
            path={Constants.taskhistory}
            component={TaskHistory}
          />
          <PrivateRoute
            exact
            path={Constants.accountdetail}
            component={AccountDetail}
          />
          <PrivateRoute exact path={Constants.accounts} component={Accounts} />
          <PrivateRoute exact path={Constants.admin} component={Admin} />
          <PrivateRoute exact path={Constants.homepage} component={HomePage} />
          <PrivateRoute
            exact
            path={Constants.runningtasks}
            component={RunningTasks}
          />
          <PrivateRoute
            exact
            path={Constants.runningtasksadmin}
            component={RunningTasksAdmin}
          />
          <Route exact path={Constants.wallremover} component={WallRemover} />
          <Route component={Login} />
        </Switch>
      </HashRouter>
      <DialogProvider />
    </>
  );
}

export default function IntegrationNotistack() {
  return (
    <Provider store={store}>
      <SnackbarProvider maxSnack={3}>
        <App />
      </SnackbarProvider>
    </Provider>
  );
}
